import { IHttpClientOpts } from './interfaces'
import { HttpClient } from './http.client'

export class HttpClientFactory {
	createClient(baseUrl: string, config: IHttpClientOpts = {}): HttpClient {
		return new HttpClient(baseUrl, config)
	}
}
